import { render, staticRenderFns } from "./DecimalSetting.vue?vue&type=template&id=57332979&"
import script from "./DecimalSetting.js?vue&type=script&lang=js&"
export * from "./DecimalSetting.js?vue&type=script&lang=js&"
import style0 from "./DecimalSetting.vue?vue&type=style&index=0&id=57332979&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports